import Api from '../Api'

const emptyForm = {
  firstName: '',
  lastName: '',
  email: '',
  password: '',
  confirmPassword: '',
  subscription: undefined
}

const newUserForm = {
  namespaced: true,
  state: {
    opened: false,
    newUser: { ...emptyForm },
    subscriptions: [],
    loadingSubscriptions: false,
    submitting: false
  },
  mutations: {
    open(state) {
      state.opened = true
    },
    close(state) {
      state.opened = false
      state.subscriptions = []
    },
    saved(state) {
      state.opened = false
      state.newUser = { ...emptyForm }
    },
    notSaved(state) {
      state.opened = true
    },
    startLoadingSubscriptions(state) {
      state.loadingSubscriptions = true
    },
    fetchedSubscriptions(state, data) {
      state.subscriptions = data.subscriptions
      state.loadingSubscriptions = false
    },
    submitting(state) {
      state.submitting = true
    },
    submitted(state) {
      state.submitting = false
    }
  },
  actions: {
    async postUser({ commit }, params) {
      commit('submitting')

      const { data: { user } } = await Api.post('/guestroom/users', params).catch((error) => {
        var description = 'Sorry, the new user was not saved. Please try again.'
        if(error.response.data.error) description = error.response.data.error
        commit('notSaved')
        commit('notification/show', { type: "error", message: "Wuh-oh!", description: description }, { root: true })
        commit('submitted')
      })

      if(user) {
        commit('saved')
        commit('notification/show', { type: "success", message: "Hurrah!", description: "New user successfully created." }, { root: true })
        commit('users/unshift', user, { root: true })
        commit('submitted')
      }
    },
    async fetchSubscriptions({ commit }, search) {
      const { data } = await Api.get('guestroom/subscriptions', {
        params: { search }
      })
      commit('fetchedSubscriptions', data)
    }
  }
}

export default newUserForm